/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getPublicSiteUrl } from "@cosmos/common-utils";

export const getApiPath = (serverUrl?: string, basePath?: string, apiPath?: string): string => {
	return `${getPublicSiteUrl(serverUrl, basePath)}${apiPath ?? process.env.NEXT_PUBLIC_COSMOS_API_PATH ?? "/api"}`;
};
